import { render, staticRenderFns } from "./dates-prices-row.vue?vue&type=template&id=20dc0d9c"
import script from "./dates-prices-row.vue?vue&type=script&lang=js"
export * from "./dates-prices-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports